module.exports = __webpack_public_path__ + "img/logo_white.02a3a434.png";